import { RouterPath } from '@src/constants/router_path';
import type { RouterPath as RouterPathType } from '@src/types/router_path';

export const mainContent: RouterPathType[] = [
  {
    name: 'menu.basicInfo',
    path: RouterPath.contact,
    pageTitle: 'pages.contact.title', // 実際のページタイトルキー
  },
  {
    name: 'menu.careerSummary',
    path: RouterPath.careerSummary,
    pageTitle: 'pages.careerSummary.title',
  },
  {
    name: 'menu.workHistory',
    path: RouterPath.history,
    pageTitle: 'pages.history.title',
  },
  {
    name: 'menu.experienceAndKnowledge',
    path: RouterPath.skill1,
    pageTitle: 'pages.skills.title1',
  },
  // スキル（2/2）ページも判定対象に含める
  {
    name: 'menu.experienceAndKnowledge',
    path: RouterPath.skill2,
    pageTitle: 'pages.skills.title2',
  },
  {
    name: 'menu.jobResponsibilities',
    path: RouterPath.project,
    pageTitle: 'pages.projects.title',
  },
  {
    name: 'menu.summaryOfEachCareer',
    path: RouterPath.historyComment,
    pageTitle: 'pages.historyComment.title',
  },
  {
    name: 'menu.thingsToChallenge',
    path: RouterPath.nextCareer,
    pageTitle: 'pages.nextCareer.title',
  },
  {
    name: 'menu.finalEducation',
    path: RouterPath.educationalBackground1,
    pageTitle: 'pages.education.title1',
  },
  // 学歴（2/2）ページも判定対象に含める
  {
    name: 'menu.finalEducation',
    path: RouterPath.educationalBackground2,
    pageTitle: 'pages.education.title2',
  },
  {
    name: 'menu.otherContents',
    path: RouterPath.otherActivity,
    pageTitle: 'pages.otherActivity.title',
  },
  {
    name: 'menu.inputStatus',
    path: RouterPath.inputStatus,
    pageTitle: 'pages.inputStatus.title',
  },
];

// 履歴書のページリスト
export const rirekishoContent: RouterPathType[] = [
  {
    name: 'menu.basicInfo',
    path: RouterPath.rirekishoBasicInfo,
    pageTitle: 'pages.rirekisho.basicInfo.title',
  },
  {
    name: 'menu.photo',
    path: RouterPath.rirekishoPhoto,
    pageTitle: 'pages.rirekisho.photo.title',
  },
  {
    name: 'menu.address',
    path: RouterPath.rirekishoAddress,
    pageTitle: 'pages.rirekisho.address.title',
  },
  {
    name: 'menu.contact',
    path: RouterPath.rirekishoContact,
    pageTitle: 'pages.rirekisho.contact.title',
  },
  {
    name: 'menu.history',
    path: RouterPath.rirekishoHistory,
    pageTitle: 'pages.rirekisho.history.title',
  },
  {
    name: 'menu.license',
    path: RouterPath.rirekishoLicense,
    pageTitle: 'pages.rirekisho.license.title',
  },
  {
    name: 'menu.motivation',
    path: RouterPath.rirekishoMotivation,
    pageTitle: 'pages.rirekisho.motivation.title',
  },
  {
    name: 'menu.personalRequests',
    path: RouterPath.rirekishoPersonalRequests,
    pageTitle: 'pages.rirekisho.personalRequests.title',
  },
  {
    name: 'menu.signature',
    path: RouterPath.rirekishoSignature,
    pageTitle: 'pages.rirekisho.signature.title',
  },
  {
    name: 'menu.inputStatus',
    path: RouterPath.rirekishoInputStatus,
    pageTitle: 'pages.rirekisho.inputStatus.title',
  },
];
